import {
  put,
  takeLatest,
  select,
  fork,
  take,
  takeEvery,
  all,
  cancel,
} from 'redux-saga/effects';

import chatConsts from '../../chatConnection/constants';
import {
  actions as reqChannelParticipants,
  consts as reqChannelParticipantsConsts,
} from '../reqChannelParticipants';
import {
  actions as dependentChannelParticipants,
  consts as dependentChannelParticipantsConsts,
} from '../dependent-channel-participants';
import { consts as reqChangeChatNameConsts } from '../reqChangeChatName';
import { consts as reqBlockUser } from '../reqBlockUser';
import { consts as reqUnblockUser } from '../reqUnblockUser';
import { consts as blockUserForDependent } from '../block-user-for-dependent';
import { consts as unblockUserForDependent } from '../unblock-user-for-dependent';
import {
  activeChannelIdSelector,
  isSocialChannelSelector,
} from '../../chatConnection/selectors';
import {
  targetUserIdSelector,
  selectIsVerifiedDependentRole,
} from '../../context/selectors';
import { APPOINTMENT_CHANNEL_ID } from '../../../constants';

function* participantsWorker({ payload }) {
  if (payload === APPOINTMENT_CHANNEL_ID) {
    yield cancel();
  }
  const activeChannelId = yield select(activeChannelIdSelector);
  const isVerifiedDependent = yield select(selectIsVerifiedDependentRole);
  const targetUserId = yield select(targetUserIdSelector);
  const isSocialChannel = yield select(isSocialChannelSelector);

  if (activeChannelId) {
    yield put(reqChannelParticipants.send({ id: activeChannelId }));
    if (isVerifiedDependent && !isSocialChannel) {
      yield put(
        dependentChannelParticipants.send({
          dependentId: targetUserId,
          id: activeChannelId,
        }),
      );

      const { loggedUserParticipantsReq, dependentParticipantsReq } = yield all(
        {
          loggedUserParticipantsReq: take(reqChannelParticipantsConsts.SUCCEED),
          dependentParticipantsReq: take(
            dependentChannelParticipantsConsts.SUCCEED,
          ),
        },
      );
      const { payload: loggedUserParticipants } = loggedUserParticipantsReq;
      const { payload: dependentParticipants } = dependentParticipantsReq;
      yield put(
        reqChannelParticipants.updateList({
          loggedUserParticipants,
          dependentParticipants,
        }),
      );
    }
  }
}

function* participantsWorkerSaga() {
  yield takeEvery(chatConsts.SET_ACTIVE_CHANNEL_ID, participantsWorker);
}

function* changeChatNameWorker(response) {
  const contextId = yield select(targetUserIdSelector);
  if (contextId) {
    yield put({
      type: chatConsts.UPDATE_CONTEXT_CHAT_NAME,
      payload: response.payload,
      contextId,
    });
  } else {
    yield put({
      type: chatConsts.UPDATE_CHAT_NAME,
      payload: response.payload,
    });
  }
}

function* chatNameWorkerSaga() {
  yield takeLatest(reqChangeChatNameConsts.SUCCEED, changeChatNameWorker);
}

function* addParticipantWorkerSaga() {
  yield takeEvery(
    [
      reqBlockUser.SUCCEED,
      reqUnblockUser.SUCCEED,
      blockUserForDependent.SUCCEED,
      unblockUserForDependent.SUCCEED,
    ],
    participantsWorker,
  );
}

export default function* root() {
  yield fork(participantsWorkerSaga);
  yield fork(chatNameWorkerSaga);
  yield fork(addParticipantWorkerSaga);
}



// WEBPACK FOOTER //
// ./src/redux/board/sagas/participants.js